<template>
  <!-- 卡片首页 -->
  <div class="comp_">
    <div
      class="item_"
      v-for="(item, index) in list"
      :key="index"
      @click="setStep(item)"
    >
      <router-link :to="item.jumpTo || '/'">
        <div class="item_1 flex_1" style="margin-right: 5px">
          <img class="img_" :src="item.img" alt="" />
        </div>
        <div class="item_1 item_2 flex_3">
          <div class="title">{{ item.title }}</div>
          <div class="describe">{{ item.sec }}</div>
        </div>
        <div class="item_1 flex_1">
          <div class="arrow"></div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 卡片列表
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    localStorage.setItem('claimPro', 0)
    sessionStorage.setItem('claimKey', '1')
  },
  methods: {
    setStep(item) {
      console.log(item)
      if (item.id == 1) {
        this.$store.commit('common/setClaimStep', '1')
        this.$store.commit('common/setClaimEdit', true)
        this.$store.commit('common/setStep', '1')
        this.$store.commit('common/setEdit', true)
        this.$store.commit('common/setNextP', true)
      }
      this.$utils.sc({
        page: '理赔业务办理',
        c: item.title
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.flex_1 {
  flex: 1;
}
.flex_3 {
  flex: 4;
}
.item_ {
  margin-top: 14px;
  &:first-child {
    margin-top: 0;
  }
  a {
    display: flex;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 10px 0px rgba(51, 51, 51, 0.05);
    border-radius: 10px;
    padding-left: 10px;
  }
  .item_1 {
    height: 87px;
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      height: 16px;
      font-size: 15px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      white-space: nowrap;
      margin-bottom: 13px;
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
    .describe {
      font-size: 0.29rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      text-align: left;
    }
    .img_ {
      height: 45px;
      width: auto;
    }
    .arrow {
      position: relative;
      height: 45px;
      width: 20px;
      &::after {
        position: absolute;
        top: 18px;
        right: 10px;
        display: block;
        content: '';
        width: 8px;
        height: 8px;
        border-top: 2px solid #333333;
        border-right: 2px solid #333333;
        transform: rotateZ(45deg);
        opacity: 0.5;
      }
    }
  }
  .item_2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
